import { render, staticRenderFns } from "./fire-quote-info.vue?vue&type=template&id=19228344&scoped=true&"
import script from "./fire-quote-info.vue?vue&type=script&lang=js&"
export * from "./fire-quote-info.vue?vue&type=script&lang=js&"
import style0 from "./fire-quote-info.vue?vue&type=style&index=0&id=19228344&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "19228344",
  null
  
)

export default component.exports